<template>
  <a
    class="btn-cu btn-color-estandar"
    :class="[{'btn-fw': fullWidth}, `btn-${size}`]"
    title="Inicia sesión con ClaveÚnica"
    @click="handleClick()"
  >
    <img class="cl-claveunica" src="@/assets/images/cu-blanco.svg"/>
    <span class="texto">Iniciar sesión</span>
  </a>
</template>

<script>
export default {
  name: 'button-clave-unica',
  props: {
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'md', 'lg'].indexOf(value) !== -1;
      }
    },
    fullWidth: {
      type: Boolean
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.btn-cu {
  display: inline-flex;
  align-items: center;
  min-height: calc(2rem + 16px); /* 48px si 1rem=16px */
  padding: 8px 14px;
  gap: 4px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1.5;
  background: #e21b3c;
  color: #fff;
  transition: background 0.2s;
}
.btn-cu:active,
.btn-cu:focus {
  outline: 2px solid #0053a6;
  outline-offset: 2px;
}
.cl-claveunica {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.texto {
  display: inline-block;
  vertical-align: middle;
}

/*Icono ClaveÚnica*/
.btn-cu .cl-claveunica {
  display: inline;
  float: left;
  text-indent: -9999px;
}
/*Texto ClaveÚnica*/
.btn-cu .texto {
  padding-left: 3px;
}

/* Tamaño S */
.btn-cu.btn-sm {
  width: 130px;
  min-width: 130px;
  height: 36px;
  padding: 8px 10px !important;
  font-size: 14px;
}

.btn-cu.btn-sm .cl-claveunica {
  width: 20px;
  height: 20px;
  background-size: 20px 20px;
}

/* Tamaño M */
.btn-cu.btn-md {
  width: 160px;
  min-width: 160px;
  height: 42px;
  padding: 8px 18px 8px 15px !important;
  font-size: 16px;
  line-height: 1.6em;
}

.btn-cu.btn-md .cl-claveunica {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

/* Tamaño L */
.btn-cu.btn-lg {
  width: 180px;
  min-width: 180px;
  height: 48px;
  padding: 11px 18px !important;
  font-size: 18px;
}

.btn-cu.btn-lg .cl-claveunica {
  width: 26px;
  height: 26px;
  background-size: 26px 26px;
}

/* Tamaño fluid-width */
.btn-cu.btn-fw {
  max-width: 550px;
  width: 100%;
  display: flex;
  justify-content: center;
}
/* Color Estandar */
.btn-cu.btn-color-estandar {
  background-color: #0F69C4;
  color: #FFF;
}
.btn-cu.btn-color-estandar:hover {
  background-color: #0C549C;
  color: #FFF;
}

.btn-cu.btn-color-estandar:active {
  background-color: #093F75;
  color: #FFF;
}

.btn-cu.btn-color-estandar:focus {
  background-color: #0C549C;
  color: #FFF;
  outline: 1px dashed #000;
}
</style>
